import styled from 'styled-components';

export const AdminPanelMainForm = styled.div`
  margin-top: 3rem;
`;
